import styled from 'styled-components';

const NewHeroSectionStyle = styled.section`
	--descMTop: var(--sp6x);
	--imageSize: 45%;

	position: relative;

	.description {
		margin-top: var(--descMTop);
		white-space: pre-wrap;
	}

	.image-block {
		.image-inner-block {
			.image-cont {
				--proportion: var(--imageSize);
			}
		}
	}

	.hero-inner-section {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 99;

		.container {
			height: 100%;

			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		&:before {
			content: '';
			position: absolute;
			z-index: -1;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: radial-gradient(521.23% 121.94% at 14.14% 90.72%, rgba(188, 21, 31, 0.37) 0%, rgba(0, 0, 0, 0.04) 100%);
		}
	}

	.svg-border {
		position: absolute;
		bottom: -1px;
		left: 0;
		right: 0;
		z-index: 99;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--descMTop: var(--sp4x);
		--imageSize: 40%;
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--descMTop: var(--sp4x);
		--imageSize: 47.6%;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--descMTop: var(--sp3x);
		--imageSize: 47.9%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--descMTop: var(--sp3x);
		--imageSize: 49%;
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--descMTop: var(--sp3x);
		--imageSize: 54.9%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--descMTop: var(--sp3x);
		--imageSize: 79.3%;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--descMTop: var(--sp3x);
		--imageSize: 190.3%;
	}
`;

export default NewHeroSectionStyle;
